<template>
	<div class="diagram-professionals mx-8 md:mx-24">
		<div class="diagram-professionals-wrapper grid grid-cols-5 grid-rows-5 row-gap-6 lg:grid-rows-1 lg:col-gap-6 px-8 py-4 lg:py-10">
			<div class="diagram-accent"></div>
			<div class="col-span-5 lg:col-span-1">
				<diagram-step text="Baseline" textBgColor="#8bcddb" iconColor="#8bcddb"/>
			</div>
			<div class="col-span-5 lg:col-span-1">
				<diagram-step text="Week 6" textBgColor="#67bed0" iconColor="#67bed0"/>
			</div>
			<div class="col-span-5 lg:col-span-1">
				<diagram-step text="Week 12" textBgColor="#4fb3c9" iconColor="#4fb3c9"/>
			</div>
			<div class="col-span-5 lg:col-span-1">
				<diagram-step text="Week 18*" textBgColor="#3ba8c0" iconColor="#3ba8c0"/>
			</div>
			<div class="col-span-5 lg:col-span-1">
				<diagram-step text="Week 24" textBgColor="#269cbd" iconColor="#269cbd"/>
			</div>
		</div>
		<p class="px-4 pb-4 lg:pb-6">*Participants in the epilepsy group complete the questionnaires at Week 18</p>
		<div class="grid grid-cols-1 px-8 pb-4">
			<div class="col-span-1">
				<h3 class="font-bold text-left text-xl lg:text-2xl">
					Assessment using validated scales for pain, sleep, anxiety, depression
				</h3>
				<link-list :data="data" />
			</div>
		</div>
	</div>
</template>
<script>
import DiagramStep from '../components/ProfessionalsDiagramStep'
import LinkList from '../components/LinkList'

export default {
	name: 'professionals-diagram',
	components: {
		'diagram-step': DiagramStep,
		'link-list': LinkList
	},
	props: {
		data: {
			type: Array
		}
	}
}
</script>

<style lang="postcss" scoped>
	.diagram-professionals {
		border: 3px solid #292637;
	}
	.diagram-professionals-wrapper {
		position: relative;
	}
	.diagram-accent {
		width: 10px;
		height: calc(100% - 2rem);
		position: absolute;
		top: 1rem;
		left: calc(2.5rem + 10px + 15px);
		background-color: #eee;
		z-index: 0;
	}
	@media screen and (min-width: 1024px) {
		.diagram-accent {
			width: calc(100% - 2rem);
			height: 10px;
			top: calc(2.5rem + 17px);
			left: 1rem;
		}
	}
</style>